<template>
	<div class="video-banner" :data-cy="dataCy">
		<Video :webm-src="webmSrc" :mp4-src="mp4Src" />

		<div class="video-banner__content" :data-cy="dataCyContent">
			<h1 class="content__title" v-html="title" />
			<router-link :to="route" class="content__button"
				><span>{{ buttonText }}</span></router-link
			>
		</div>
	</div>
</template>

<script>
import Video from '@/components/shared/Video';

export default {
	props: {
		webmSrc: {
			type: Object,
			default: () => ({})
		},
		mp4Src: {
			type: Object,
			default: () => ({})
		},
		title: {
			type: String,
			default: ''
		},
		buttonText: {
			type: String,
			default: ''
		},
		route: {
			type: Object,
			default: () => ({})
		},
		dataCy: {
			type: String,
			default: ''
		},
		dataCyContent: {
			type: String,
			default: ''
		}
	},
	components: {
		Video
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/brand-container.scss';
@import '@/styles/mixins/brand-button.scss';
@import '@/styles/mixins/brand-fonts.scss';
.video-banner {
	height: 100vh;
	width: 100vw;
	max-width: 100%;
	overflow: hidden;
	position: relative;
	&__content {
		@include Brand-Container(md);
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
		.content {
			&__title {
				font-family: $brand-font-blacker-bold;
				font-size: 62px;
				letter-spacing: -0.5px;
				line-height: 56px;
				color: $brand-white;
				text-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
				margin-top: 100px;
				sup {
					top: -0.25em;
					position: relative;
					font-size: 75%;
					line-height: 0;
					vertical-align: baseline;
				}
			}
			&__button {
				@include Brand-Button(outline-white, md);
				margin-top: 200px;
			}
		}
	}
}
</style>
